<template>
    <h3 class="uk-margin-top">{{ $t("Personalisierung") }}</h3>
    <div class="uk-overflow-auto">
        <table class="uk-table uk-table-striped uk-margin-remove-top">
            <thead>
                <tr>
                    <td class="uk-text-bold">{{ $t('Ticket') }}</td>
                    <td class="uk-text-bold" v-for="field in fields">
                        {{ label(field.floating) }}
                    </td>
                </tr>
            </thead>
            <tbody>
                <template v-for="selection in store.state.selection">
                    <tr v-for="person in selection.persons">
                        <td>{{ selection.ticket.name }}</td>
                        <td v-for="(field, key) in fields">
                            {{ value(field, person[key]) }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import {useStore} from "vuex";
import {displayValue, localizedText, valueFields} from "../../helper/personalizeDisplay";

export default {
    data: () => ({store: useStore()}),
    computed: {
        /**
         * Die Felder, die eine Spalte verdienen. Ohne den Filter erzeugt ein
         * static-Feld — reiner Erklärtext im Formular — eine Spalte ohne Kopf
         * und ohne Inhalt.
         */
        fields() {
            return valueFields(this.store.state.vue_personalize_fields)
        },
    },
    methods: {
        /**
         * floating ist normalerweise {de: …, en: …}, bei manchen Feldern aber
         * ein leerer String. Der Helper nimmt beides.
         */
        label(floating) {
            return localizedText(floating, this.$root.$i18n.locale)
        },
        /**
         * Im Store steht der Wert, der ANS BACKEND geht — beim Select der
         * Options-Key ('option_yes'), beim Datum das value-format
         * ('2010-01-01'). Angezeigt werden soll, was im Formular zu lesen war.
         */
        value(field, raw) {
            return displayValue(field, raw, this.$root.$i18n.locale)
        },
    },
}
</script>
